// store/cacheSlice.js
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
interface CacheState {
  [key: string]: any;
  getFeedMetaData: null | {
    [key: string]: any;
  };
  fetchProducts: null | {
    [key: string]: any;
  };
  filter?: null | {
    [key: string]: any;
  };
}
const initialState: CacheState = {
  getFeedMetaData: {},
  fetchProducts: {},
  filter: {}
};
const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    setCache: (state, action: PayloadAction<{
      key: string;
      data: any;
    }>) => {
      const {
        key,
        data
      } = action.payload;
      state[key] = data;
    },
    setFeedMetaResponse: (state, action: PayloadAction<any>) => {
      state.getFeedMetaData = {
        ...action.payload,
        ...state.getFeedMetaData
      };
    },
    clearFeedMetaResponse: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      const updatedCache = {
        ...state.getFeedMetaData
      };
      if (updatedCache && updatedCache[key]) delete updatedCache[key];
      state.getFeedMetaData = updatedCache;
    },
    setProductResponse: (state, action: PayloadAction<any>) => {
      state.fetchProducts = {
        ...action.payload,
        ...state.fetchProducts
      };
    },
    clearProductResponse: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      const updatedCache = {
        ...state.fetchProducts
      };
      if (updatedCache && updatedCache[key]) delete updatedCache[key];
      state.fetchProducts = updatedCache;
    },
    setFilterResponse: (state, action: PayloadAction<any>) => {
      state.filter = {
        ...action.payload,
        ...state.filter
      };
    },
    clearFilterResponse: state => {
      state.filter = {};
    },
    clearCache: (state, action: PayloadAction<{
      key?: string;
    }>) => {
      if (action.payload.key) {
        delete state[action.payload.key];
      } else {
        Object.keys(state).forEach(k => delete state[k]);
      }
    }
  }
});
export const {
  setCache,
  clearCache,
  setFeedMetaResponse,
  clearFeedMetaResponse,
  setProductResponse,
  clearProductResponse,
  setFilterResponse,
  clearFilterResponse
} = cacheSlice.actions;
export const selectFeedMetaData = (state: RootState) => state.cache.getFeedMetaData;
export const selectProductFilters = (state: RootState) => state.cache.filter;
export const selectProductResponse = (state: RootState) => state.cache.fetchProducts;
export default cacheSlice;